import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

export const AnswerBlock = styled.div`
  ${maxMediaQueries.phablet`
    margin-left: -24px;
    margin-right: -24px;
  `};

  ${maxMediaQueries.phone`
    margin-left: -15px;
    margin-right: -15px;
  `};
`;
